import hive from './hive';
import steem from './steem';

const hasPostingAuthority = (account, chain) => {
  return chain.api
    .getAccountsAsync([account])
    .then(r => {
      const postingAuths = r[0].posting.account_auths;
      return new Promise(resolve => {
        postingAuths.forEach(acc => {
          if (acc[0] === 'travelfeed.app') resolve(true);
        });
        resolve(false);
      });
    })
    .catch(() => {
      return new Promise(resolve => {
        resolve(undefined);
      });
    });
};

export const hasSteemPostingAuthority = account => {
  return hasPostingAuthority(account, steem);
};

export const hasHivePostingAuthority = account => {
  return hasPostingAuthority(account, hive);
};

export const requestPostingAuthority = async user => {
  return new Promise(resolve => {
    window.hive_keychain.requestAddAccountAuthority(
      user,
      'travelfeed.app',
      'posting',
      1,
      response => {
        resolve(response);
      },
    );
  });
};
